export enum InfluencedFileOutputsStatusEnum {
  PREVIEW = 'preview',
  SIGNUP = 'signup',
  CHRONIQUES = 'chroniques',
}
